const SliderCard = ({ children }) => (
  <div>
    {children}
  </div>
);

export default SliderCard;
